import React from 'react';
import { FacebookIcon, FacebookShareButton as FBButton } from 'react-share';

export const FacebookShareButton: React.FC = () => {
  return (
    <FBButton
      className={'onm-social facebook'}
      url="https://www.facebook.com/outbreaksnearme.org/"
    >
      <FacebookIcon size={32} />
      Facebook
    </FBButton>
  );
};
